import { useEffect } from "react";
import { useToast } from "@salesapp/ui";
import { CONTENT_SANITIZED_EVENT } from "../lib/api";

/**
 * The API stores plain text only and removes HTML-style tags (and stray < or > characters) from
 * anything typed into a field. It says so in a response header; this turns that into a short notice
 * so the user is not left wondering why `<b>text</b>` came back as `text`.
 */
export function SanitizedNotice() {
  const { show } = useToast();
  useEffect(() => {
    const onSanitized = (event: Event) => {
      const fields = (event as CustomEvent<{ fields?: string[] }>).detail?.fields ?? [];
      if (fields.length === 0) return;
      show(
        `Saved, but HTML tags and < > characters were removed from: ${fields.join(", ")}. Text is stored as plain text.`,
        "info",
      );
    };
    window.addEventListener(CONTENT_SANITIZED_EVENT, onSanitized);
    return () => window.removeEventListener(CONTENT_SANITIZED_EVENT, onSanitized);
  }, [show]);
  return null;
}
